import { StarFilled } from '@1debit/icons';

type FiveStarsProps = {
  testId?: string;
};

const FiveStars = ({ testId }: FiveStarsProps) => {
  const stars = Array(5).fill('');
  const testFixture = testId ?? 'five-stars';

  return (
    <div className="flex gap-[3px]" data-testid={`${testFixture}-wrapper`}>
      {stars.map((_, i) => (
        <div key={i} className="w-max h-max" data-testid={`${testFixture}-item`}>
          <StarFilled className="max-w-8" />
        </div>
      ))}
    </div>
  );
};

export default FiveStars;
